<template>
  <div class="receive-dialog" v-if="visible">
    <slot name="title"></slot>
    <!-- <h2 class="title">输入手机号码领取</h2> -->
    <slot name="body"></slot>
    <a class="close" href="javascript:;" @click="handleClose"/>
    <slot name="footer"></slot>
  </div>
</template>

<script>
import BenefitButton from '@/components/benefit/button.vue'
import eventHub from '../../pages/benefit/eventHub';
export default {
  components: {
    BenefitButton
  },
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    type: {
      type: Number,
      required: true
    }
  },
  methods: {
    handleClose() {
      eventHub.$emit('update:visible', this.type, false)
    },
    handleGetVerificationCode() {
      if (this.type === 1) {
        this.$el.querySelectorAll('input')[1].focus()
      }
    },
    handleShowIntro() {},
    validatePhoneNumber() {}
  },
  watch: {
    visible(newValue) {
      if (newValue && this.type === 1) {
        this.$nextTick(() => {
          this.$el.querySelector('input').focus();
        })
      }
    },
  },
  created() {
    eventHub.$on('click:getVerificationCode', this.handleGetVerificationCode.bind(this))
  }
}
</script>

<style lang="scss">
.receive-dialog {
  width: 320px;/*no*/
  z-index: 3;
  background: white;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 8px;/*no*/
  .close {
    position: absolute;
    display: block;
    right: 12px;/*no*/
    top: 12px;/*no*/
    width: 24px;/*no*/
    height: 24px;/*no*/
    background-image: url('~assets/benefit/close@3x.png');
    background-size: contain;
  }
}
</style>
